export default "__VITE_ASSET__BvdmK3k9__"